<template>
    <!-- <div>        
        <h1 class="title">Turblatt Kurzung oder Verlangerung</h1>
            <div class="group-wrapper">
                <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                    <label  v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM').values" :key="index"
                    :class="{ 'btn':true, 'btn-secondary':true, 'active': checkRadioValue(getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM').code, valueDefinition.value)}"
                     @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM'), valueDefinition: valueDefinition })">
                        <div class="radio-btn">
                            <span></span>
                        </div>
                        <input type="radio" autocomplete="off" v-model="selectedCharacteristic"> {{ valueDefinition.description }}
                    </label>
                </div>
            </div> 
        <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">{{this.selectedCharacteristic.description}}</span>
                </div>
                <input type="text" v-model="doorLeafCharacteristic" 
                :class="{'form-control' : true}" :disabled="this.selectedCharacteristic.value === 'NEIN'" aria-label="Default" aria-describedby="inputGroup-sizing-default" value="" >
                <span class="post">mm</span>
        </div>             
    </div> -->
    <div>
        <v-radio-group v-model="computedSelectedCharacteristic" row>
            <template>
                <v-row>
                    <v-col cols="4" class="py-2"
                        v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM').values"
                        :key="index">
                        <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                            @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('CUST_MM_TUERBLATT_FORM'), valueDefinition: valueDefinition })">
                        </v-radio>
                    </v-col>
                </v-row>
            </template>
        </v-radio-group>

        <div class="mb-6">
            <div>
                <div class="body-2 pb-2" style=""></div>
                <v-text-field class="unit-text-field" :disabled="this.selectedCharacteristic.value === 'NEIN'"  v-model="doorLeafCharacteristic" dense outlined hide-details suffix="mm">
                </v-text-field>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';  
import { Characteristic, ValueDefinition, MapCharacteristicAndValue } from '../../../configurator/types';  
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';       
import { forEach } from 'typescript-collections/dist/lib/arrays';
import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService';

export default Vue.extend({
    name: 'DoorLeaf',        
    props: {
                  
    },
    data() {
        return {
            parseToGermanFloat: parseToGermanFloat,
            parseFloatFromGermanFloat: parseFloatFromGermanFloat,
            measureContext: DoorConfiguration.Measure,
            DoorLeafFormCharacteristics : [
                {
                    Key : "VER",
                    Value : "KTU_MM_TUERBL_VERLAENGERUNG"
                },
                {
                    Key : "KUE",
                    Value : "KTU_MM_TUERBL_KUERZUNG"
                },
                {
                    Key : "NEIN",
                    Value : "NEIN"
                },
            ],
            selectedCharacteristic : {},
            doorLeafCharacteristicValue : 0,
        }
    },
    computed : {
        ...mapGetters('configuratorModule',['getCurrentDoorConfiguration','getRegisteredCharacteristicsValue']),
        ...mapGetters('measureModule', ['getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue','getSelectedDoorLeafCharacteristic',]),
        doorLeafCharacteristic: {
                //getter
                get: function () {
                    this.setRegisteredSelectedRadio();
                    
                    if(this.selectedCharacteristic.value !== "NEIN"){
                        
                        this.doorLeafCharacteristicValue = this.getRegisteredCharacteristicsValue(this.DoorLeafFormCharacteristics.filter((item) => item.Key === this.selectedCharacteristic.value)[0].Value, this.measureContext).value.value;
                    } else {
                        this.doorLeafCharacteristicValue = 0;
                    }
                    return this.parseToGermanFloat(this.doorLeafCharacteristicValue);
                },
                // setter
                set: function (newValue) {
                    newValue = this.parseFloatFromGermanFloat(newValue);
                    this.doorLeafCharacteristicValue = newValue;
                    this.changeCharacteristicsValue();
                }
            },

            computedSelectedCharacteristic : function()
            {
                return this.getRegisteredCharacteristicsValue('CUST_MM_TUERBLATT_FORM', this.measureContext).value.value;
            }
    },
    methods: {
        ...mapActions('configuratorModule',['updateDoorConfiguration']),
        ...mapActions('measureModule', ['addCharacterisitc','setDoorLeafCharacteristic','valueAddCharacteristic']),
        handleRadioSelect(characteristic ,valueDefinition ){
                this.selectedCharacteristic = characteristic.valueDefinition;
                this.changeCharacteristicsValue();
        },
        getDoorLeafCharacteristic(value ) {
            return this.getCharacteristicAndValues(this.DoorLeafFormCharacteristics.filter((item) => item.Key === value)[0].Value);
        },
        changeCharacteristicsValue(){
               
            if(this.selectedCharacteristic.value === "NEIN"){
                
            this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues(this.DoorLeafFormCharacteristics.filter((item) => item.Key === "VER")[0].Value), value: 0 });
            
            this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues(this.DoorLeafFormCharacteristics.filter((item) => item.Key === "KUE")[0].Value), value: 0 });
            }else {
                
                const previousChar = this.DoorLeafFormCharacteristics.filter((item) => item.Key != this.selectedCharacteristic.value && item.Key != "NEIN")[0].Value;
                this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues(previousChar), value: 0 });
                
                this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues(this.DoorLeafFormCharacteristics.filter((item) => item.Key === this.selectedCharacteristic.value)[0].Value), value: this.doorLeafCharacteristicValue });
                } 
        },
        setRegisteredSelectedRadio(){
            this.selectedCharacteristic = this.getRegisteredCharacteristicsValue("CUST_MM_TUERBLATT_FORM", this.measureContext).value;
        }
    },
    mounted() {
            
    },

});
</script>
<style scoped>

</style>